<template>
  <div
    class="profile-header"
    :class="{ 'profile-header--with-border': showBorder }"
  >
    <user-avatar
      :user="user"
      size="full"
      :display-tooltip="false"
      class="profile-header__avatar"
    />
    <component
      :is="this.$route.name === 'userProfileOverview' ? 'h1' : 'p'"
      class="profile-header__name"
      data-test-id="user-profile-header-name"
    >
      {{ profileHeaderName }}
    </component>
    <role-badge :user="user" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UserAvatar from '@/components/User/UserAvatar.vue';
import RoleBadge from '@/components/User/RoleBadge.vue';

export default {
  name: 'ProfileHeader',
  components: {
    UserAvatar,
    RoleBadge,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters([
      'siteHasFeature',
    ]),
    showBorder() {
      const routesWithoutBorder = ['userProfileOverview', 'memberProfile'];
      return !routesWithoutBorder.includes(this.$route.name);
    },
    siteIsSHN() {
      return this.siteHasFeature('social_network');
    },
    userHasFirstAndLastName() {
      return this.user.firstName && this.user.lastName;
    },
    profileHeaderName() {
      if (this.siteIsSHN && this.userHasFirstAndLastName) {
        return `${this.user.firstName} ${this.user.lastName}`;
      }
      return this.user.username;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_profile-header';
</style>

<docs>
Profile Heading

</docs>
